import { Splitter } from 'antd';
import { messageMenu } from '@/configs/router/menu';
import Paths from '@/configs/router/paths';
import { useChatContext } from '@/contexts/chat/context';
import MessageHeader from './components/messageHeader';
import { SplitterMsgData } from './type';
import styles from './index.module.scss';
import StatusBox from './components/StatusBox';

const Messages = () => {
  const [cacheMsgTypes, setCacheMsgTypes] = useState<string[]>([]);
  const location = useLocation();
  const params = useParams();
  const { loading } = useChatContext();
  useLayoutEffect(() => {
    if (
      location.pathname &&
      !cacheMsgTypes.includes(location.pathname) &&
      location.pathname.includes(Paths.MESSAGES_PATH)
    ) {
      setCacheMsgTypes((oldCacheMsgTypes) => [...oldCacheMsgTypes, location.pathname]);
    }
  }, [location.pathname, params.type, cacheMsgTypes]);

  return (
    <Splitter className={styles.messages}>
      <Splitter.Panel
        defaultSize={SplitterMsgData.DEFAULT_SIZE_AND_MIN}
        min={SplitterMsgData.SIZE}
        className={styles.messagesSider}
      >
        {loading && (
          <div className={styles.loading}>
            <StatusBox loading={loading}></StatusBox>
          </div>
        )}
        <MessageHeader></MessageHeader>
        {messageMenu?.map((item) => {
          if (cacheMsgTypes.includes(item.key as string)) {
            return (
              <div
                className={styles.msgSider}
                key={item.key}
                hidden={item.key !== location.pathname}
              >
                {item.siderElement}
              </div>
            );
          }
          return null;
        })}
      </Splitter.Panel>
      <Splitter.Panel min={SplitterMsgData.SIZE}>
        {messageMenu?.map((item) => {
          if (cacheMsgTypes.includes(item.key as string)) {
            return (
              <div
                className={styles.msgContainer}
                key={item.key}
                hidden={item.key !== location.pathname}
              >
                {item.element}
              </div>
            );
          }
          return null;
        })}
      </Splitter.Panel>
    </Splitter>
  );
};
export default Messages;
